import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { AuthentificationService } from '../../../providers/Global/authentification.service';
import { EditService } from '../../../providers/edit/edit.service';

import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import { PlaylistVoteBaseComponent } from '../playlistVoteBase.component';

interface PreselectCategory {
  id: number;
  label: string;
}

@Component({
  selector: 'app-edit-preselect-category',
  templateUrl: './editPreselectCategory.component.html',
  styleUrls: ['./editPreselectCategory.component.scss']
})
export class EditPreselectCategoryComponent extends PlaylistVoteBaseComponent implements OnInit {

  // ============================================================================
  // Références de vue (implémentation des getters abstraits de la base)
  // ============================================================================
  @ViewChild('Paginator', { static: false }) private _paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) private _sort: MatSort;
  @ViewChildren('audioHLS') private _audioPlayers: QueryList<ElementRef<HTMLAudioElement>>;
  @ViewChildren('audioExtrait') private _audioExtraits: QueryList<ElementRef<HTMLAudioElement>>;

  protected get paginator() { return this._paginator; }
  protected get sort() { return this._sort; }
  protected get audioPlayers() { return this._audioPlayers; }
  protected get audioExtraits() { return this._audioExtraits; }

  // ============================================================================
  // Permission
  // ============================================================================
  protected get requiredPermission(): string { return 'edit_winmedia_preselect_category'; }

  // ============================================================================
  // Colonnes du tableau (plus restreintes que la page mensuelle)
  // ============================================================================
  displayedColumns: string[] = [
    'position', 'score', 'player', 'vote', 'performer_title', 'year', 'votes_detail', 'imedia'
  ];
  displayedColumnsEditMode: string[] = [
    'dragHandle', 'position', 'score', 'player', 'vote', 'performer_title', 'year', 'votes_detail', 'imedia', 'actions'
  ];

  // ============================================================================
  // Sélection par catégorie
  // ============================================================================
  categories: PreselectCategory[] = [];
  selectedCategory: PreselectCategory;

  constructor(
    router: Router,
    authentificationService: AuthentificationService,
    editService: EditService,
    dialog: MatDialog,
    snackBar: MatSnackBar,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    super(router, authentificationService, editService, dialog, snackBar, iconRegistry, sanitizer);
  }

  ngOnInit(): void {
    this.editService.getPreselectCategories()
      .then(res => {
        this.categories = res;
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[0];
          this.setTableWinmediaPreselectCategory();
        }
      })
      .catch(err => {
        console.error('Erreur chargement catégories preselect:', err);
      });
  }

  // ============================================================================
  // Implémentation des méthodes abstraites
  // ============================================================================

  /**
   * Génère l'identifiant de la playlist au format "category_{slug}"
   * Ex : "category_pop_rock", "category_variete_francaise"
   */
  getPlaylistId(): string {
    return `category_${this.slugify(this.selectedCategory.label)}`;
  }

  private slugify(value: string): string {
    return value
      .normalize('NFD')               // décomposer les caractères accentués
      .replace(/[\u0300-\u036f]/g, '') // supprimer les diacritiques
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')    // remplacer tout caractère non alphanumérique par _
      .replace(/^_+|_+$/g, '');       // supprimer les _ en début/fin
  }

  getStationId(): number {
    return 0;
  }

  // ============================================================================
  // Chargement des données spécifique à la catégorie
  // ============================================================================

  setTableWinmediaPreselectCategory(): void {
    this.loadDataForSelection(
      () => this.editService.getWinmediaPreselectCategory(this.selectedCategory.label)
    );
  }
}
